export default "__VITE_ASSET__nFC7D9NA__"